export default __webpack_public_path__ + "static/media/solidity.225ddb61.svg";